var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("timeline-item-card", {
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "b-row",
              { staticClass: "align-items-center" },
              [
                _c(
                  "b-col",
                  [
                    _c("i18n", {
                      staticClass: "mb-0",
                      attrs: {
                        path: "client-profile.changelog.markActiveInactiveMessage",
                        tag: "p",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "name",
                          fn: function () {
                            return [
                              _c("span", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getChangelogName(_vm.userDetails)
                                    ) +
                                    "\n            "
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "status",
                          fn: function () {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "bold",
                                  class: {
                                    "text-danger": !_vm.value.to,
                                    "text-primary": _vm.value.to,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.getClientProfileStatus(_vm.value.to)
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }